import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurriculumPersistenceService } from '../services/curriculum-persistence.service';
import { CurriculumConstants } from '../constants/curriculum.contants';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-curriculum-slider',
  templateUrl: './curriculum-slider.component.html',
  styleUrls: ['./curriculum-slider.component.scss']
})
export class CurriculumSliderComponent implements OnInit{
  @Output() isCurriculumSliderActive = new EventEmitter<boolean>();
  @Input() isCurriculumSliderOpen: boolean = false;
  @Input() selectedScope: any = [];
  @Input() eqmsScopeTreeNodes: TreeNode[] = [];
  errorIconClassForDocumentTab = '';
  errorIconClassForCourseTab = '';
  currentTab = 0;
  activeTab = 0;
  constructor(private curriculumPersistenceService : CurriculumPersistenceService){

  }

  ngOnInit(): void {
    this.curriculumPersistenceService.closeAndResetCurriculumSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetCurriculumSlider(); }
    });

    this.curriculumPersistenceService.populateErrorsForTab$.subscribe((validateTabs) => {
      if(validateTabs) {
        this.showErrorIconForTab();
      }
    });
  }

  closeSlider(){
    this.curriculumPersistenceService.openConfirmationDialog();
  }

  closeAndResetCurriculumSlider(){
    this.isCurriculumSliderOpen = false;
    this.activeTab = 0;
    this.currentTab = 0;
    this.curriculumPersistenceService.onTabChange(-1);
    this.curriculumPersistenceService.onCustomTabChange(-1);
    this.isCurriculumSliderActive.emit(this.isCurriculumSliderOpen);
  }

  openCurrentTab = (tabIndex: number) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  }
  onTabChange = (event: any) => {
    this.curriculumPersistenceService.onTabChange(this.currentTab);
    this.curriculumPersistenceService.onCustomTabChange(event.index);
    this.currentTab = event.index;
  }
  showErrorIconForTab = () => {
    this.errorIconClassForDocumentTab = '';
    this.errorIconClassForCourseTab = '';
    this.curriculumPersistenceService.errorTabIndices.forEach((tabIndex) => {
      switch (tabIndex) {
        case CurriculumConstants.Curriculum_Menu_Document_Tab_Index:
          this.errorIconClassForDocumentTab = 'pi pi-exclamation-triangle';
          break;
        case CurriculumConstants.Curriculum_Menu_Course_Tab_Index:
          this.errorIconClassForCourseTab = 'pi pi-exclamation-triangle';
          break;
      }
    })

  }
}
